import en from './en'
import cn from './cn'
const messages = {
    en: {
        message:en
    },
    cn: {
        message:cn
    }
}
export default messages;